export default "__VITE_ASSET__Do$qc$eh__"